import React from "react";
import Covid from "./Covid";
import { useForm } from "react-hook-form";
import { API_URL } from "../constant";

const PageCTA = () => {
  const [loading, setLoading] = React.useState(false);
  const [size, setSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const { register, handleSubmit, setValue } = useForm({
    mode: "onSubmit",
    reValidateMode: "onChange",
    defaultValues: {},
    resolver: undefined,
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
  });

  React.useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onSubmitHandler = (value) => {
    console.log("onSubmitHandler", value);
    if (loading) {
      return;
    }
    setLoading(true);
    fetch(API_URL + "contactpro", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...value,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.success) {
          alert("Votre demande de contact à été reçu.");
          window.location.reload();
        } else {
          alert("Réessayer plus tard");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        alert("Réessayer plus tard");
      });
  };

  return (
    <>
      <div class="groupe-1344">
        <div class="overlap-group244">
          <div
            style={{
              width:
                size.width >= 1700 || size.width <= 1300
                  ? "95%"
                  : size.width >= 1600
                  ? "100%"
                  : "97%",
              margin: "auto",
            }}
          >
            <h1 class="grante-dun-salon">
              Gérant(e) d’un salon ou d’une institut?
              <br />
              Adoptez le réflex On Fleek !
            </h1>
            <div class="remplissez-le-formul roboto-normal-white-18px">
              Remplissez le formulaire ci-dessous et nous vous contacteront au
              plus vite.
            </div>
            <div class="dj-membre-connectez-vous roboto-normal-white-18px">
              Déjà membre ? Connectez-vous
            </div>
            <a href="https://pro-onfleek.re" target={"_blank"}>
              <div class="btn-annuler">
                <div class="connexion">Connexion</div>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div
        className="content-bloc"
        style={{
          padding: size.width <= 428 ? "35px 0px" : "35px 20px ",
        }}
      >
        <form
          onSubmit={handleSubmit(onSubmitHandler, (err) => {
            console.log(err);
          })}
        >
          <div
            class="row"
            style={{ flexDirection: size.width <= 428 && "column" }}
          >
            <div className="col-50">
              <input
                className="roboto-normal-16px"
                style={{ padding: "10px", border: "none" }}
                id="name"
                name="name"
                placeholder="Nom"
                type="text"
                required
                onChange={(e) => setValue("name", e.target.value)}
                ref={register("name")}
              />

              <div
                style={{
                  marginBottom: 9,
                  backgroundColor: "#BFBFBF",
                  width: "100%",
                  height: 1,
                }}
              />
            </div>

            <div class="col-50">
              <input
                className="roboto-normal-16px"
                style={{ padding: "10px", border: "none" }}
                id="firstname"
                name="firstname"
                placeholder="Prénom"
                required
                onChange={(e) => setValue("firstname", e.target.value)}
                ref={register("firstname")}
              />
              <div
                style={{
                  marginBottom: 9,
                  backgroundColor: "#BFBFBF",
                  width: "100%",
                  height: 1,
                }}
              />
            </div>
          </div>

          <div
            class="row"
            style={{
              flexDirection: size.width <= 428 && "column",
              padding: size.width > 428 && "70px 0px",
            }}
          >
            <div class="col-50">
              {/* <label for="expyear">Année d'éxpiration</label> */}

              <input
                className="roboto-normal-16px"
                style={{
                  padding: "10px",
                  border: "none",
                  width: "100%",
                }}
                id="address"
                name="address"
                placeholder="Adresse"
                required
                type={"text"}
                onChange={(e) => setValue("address", e.target.value)}
                ref={register("address")}
              />
              <div
                style={{
                  marginBottom: 9,
                  backgroundColor: "#BFBFBF",
                  width: "100%",
                  height: 1,
                }}
              />
            </div>
            <div class="col-50">
              <input
                className="roboto-normal-16px"
                style={{ padding: "10px", border: "none" }}
                type="phone"
                id="tel"
                name="tel"
                placeholder="Téléphone"
                required
                onChange={(e) => setValue("tel", e.target.value)}
                ref={register("tel")}
              />
              <div
                style={{
                  marginBottom: 9,
                  backgroundColor: "#BFBFBF",
                  width: "100%",
                  height: 1,
                }}
              />
            </div>
          </div>

          <div
            class="row"
            style={{ flexDirection: size.width <= 428 && "column" }}
          >
            <div class="col-50">
              {/* <label for="expyear">Année d'éxpiration</label> */}
              <input
                className="roboto-normal-16px"
                style={{ padding: "10px", border: "none" }}
                id="mail"
                name="mail"
                placeholder="Mail"
                required
                type="email"
                onChange={(e) => setValue("mail", e.target.value)}
                ref={register("mail")}
              />
              <div
                style={{
                  marginBottom: 9,
                  backgroundColor: "#BFBFBF",
                  width: "100%",
                  height: 1,
                }}
              />
            </div>
            <div class="col-50">
              <input
                className="roboto-normal-16px"
                style={{ padding: "10px", border: "none" }}
                type="text"
                id="gender"
                name="gender"
                placeholder="Vous êtes un (salon de coiffure, institut de beauté ...)"
                onChange={(e) => setValue("gender", e.target.value)}
                ref={register("gender")}
              />
              <div
                style={{
                  marginBottom: 9,
                  backgroundColor: "#BFBFBF",
                  width: "100%",
                  height: 1,
                }}
              />
            </div>
          </div>

          <div
            class="row"
            style={{
              paddingTop: size.width > 428 && 70,
              flexDirection: size.width <= 428 && "column",
            }}
          >
            <div class="col-50">
              {/* <label for="expyear">Année d'éxpiration</label> */}

              <textarea
                className="roboto-normal-16px"
                style={{
                  padding: "10px",
                  border: "none",
                  height: 132,
                  width: "100%",
                }}
                id="message"
                name="message"
                placeholder="Votre message (facultatif)"
                onChange={(e) => setValue("message", e.target.value)}
                ref={register("message")}
              />
              <div
                style={{
                  marginBottom: 9,
                  backgroundColor: "#BFBFBF",
                  width: "100%",
                  height: 1,
                }}
              />
            </div>
          </div>

          <div style={{ padding: "30px 0px 0px 0px", width: 196 }}>
            {loading ? (
              <div style={{ width: 55 }}>
                <div class="loader" />
              </div>
            ) : (
              <button
                type="submit"
                style={{
                  padding: 0,
                  border: "none",
                  backgroundColor: "transparent",
                  fontSize: 14,
                }}
              >
                <div
                  class=" border-2px-eerie-black"
                  style={{
                    cursor: "pointer",
                    borderRadius: 10,
                    display: "flex",
                    height: 55,
                    width: 110,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    class="sinscrire raleway-bold-eerie-black-14px"
                    style={{}}
                  >
                    Envoyer
                  </div>
                </div>
              </button>
            )}
          </div>
        </form>
      </div>

      <div class="a-propos-pro">
        <div class="on-fleek-vous-accompagne-au-quotidien-pro raleway-extra-bold-eerie-black-45px">
          On Fleek vous accompagne au quotidien
        </div>
        <div class="flex-row-pro">
          <div class="augmentation-de-vo roboto-bold-black-20px">
            • Augmentation de votre visibilité sur le web
          </div>
          <div class="automatisation-des-rendez-vous roboto-bold-black-20px">
            • Automatisation des rendez-vous
          </div>
          <div class="rduire-labsentisme roboto-bold-black-20px">
            • Réduire l’absentéisme
          </div>
        </div>
      </div>

      <div
        class="row"
        style={{
          width:
            size.width == 1024
              ? "94%"
              : size.width <= 1300
              ? "89%"
              : size.width < 1500
              ? "76%"
              : "77%",
          margin: "60px auto",
        }}
      >
        <div class="col-75" style={{ paddingLeft: 0, paddingRight: 0 }}>
          {size.width <= 428 && (
            <img
              class="boost-visibilite-on-fleek"
              src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6239ce2c29bb67c368f8717c/img/boost-visibilite-on-fleek@1x.png"
            />
          )}
          <div class="container" style={{ paddingLeft: 0, paddingRight: 0 }}>
            <div
              className="content-bloc"
              style={{
                width: "100%",
                display: size.width > 428 ? "flex" : "inherit",
                flexDirection: size.width <= 428 && "column",
              }}
            >
              <div
                class="col-50"
                style={{ padding: 0, maxWidth: size.width - 50 }}
              >
                <div class="ez-vo raleway-extra-bold-eerie-black-45px">
                  Augmentez votre visibilité
                </div>
                <div class="grce-au-planning-en">
                  <span class="roboto-normal-black-18px">Grâce au </span>
                  <span class="span19">planning en ligne</span>
                  <span
                    class="roboto-normal-black-18px"
                    style={{ fontSize: size.width <= 428 && 15 }}
                  >
                    , gérer l’intégralité de vos rendez-vous physiques ou en
                    ligne, en un seul et même lieu. Concentrez-vous sur votre
                    travail, fini les appels pendant les prestations, les prises
                    de notes sur feuilles volantes, dans un cahier, etc. Chaque
                    nouveau rendez-vous pris&nbsp;&nbsp;en ligne, ou entré
                    manuellement par vous, sera directement visible sur un
                    calendrier,&nbsp;&nbsp;que vous pourrez consulter sur votre
                    téléphone, tablette ou ordinateur.
                  </span>
                </div>
              </div>
              {size.width > 428 && (
                <div
                  class="col-25"
                  style={{
                    marginLeft: 40,
                    display: "flex",
                    padding: 0,
                  }}
                >
                  <img
                    class="boost-visibilite-on-fleek"
                    src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6239ce2c29bb67c368f8717c/img/boost-visibilite-on-fleek@1x.png"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          padding: size.width <= 428 ? "30px 0px" : " 60px 0px",
          backgroundColor: "var(--seashell)",
        }}
      >
        <div
          class="row"
          style={{
            width:
              size.width == 1024
                ? "94%"
                : size.width <= 1300
                ? "89%"
                : size.width < 1500
                ? "76%"
                : "77%",
            margin: size.width <= 428 ? "0px auto" : "60px auto",
          }}
        >
          <div class="col-75" style={{ paddingLeft: 0, paddingRight: 0 }}>
            <div class="container" style={{ paddingLeft: 0, paddingRight: 0 }}>
              <div
                className="content-bloc"
                style={{
                  width: "100%",
                  display: size.width > 428 ? "flex" : "inherit",
                  flexDirection: size.width <= 428 && "column",
                }}
              >
                <img
                  class="boost-visibilite-on-fleek"
                  style={{
                    marginLeft: 0,
                    marginRight: 40,
                    marginBottom: size.width <= 428 && 30,
                  }}
                  src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6239ce2c29bb67c368f8717c/img/automat-rdv-on-fleek@1x.png"
                />
                {/* </div> */}
                <div class="col-50" style={{ padding: 0 }}>
                  <div class="ez-vo raleway-extra-bold-eerie-black-45px">
                    Automatisez vos RDV
                  </div>
                  <div class="grce-au-planning-en">
                    <span class="roboto-normal-black-18px">
                      Simplifiez votre travail et gagnez en sérénité lors de vos
                      prestations, en automatisant la prise de rendez-vous
                      24h/24 et 7j/7 grâce à votre agenda connecté en temps
                      réel. Aucune comission ne vous sera jamais demandé.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row"
        style={{
          width:
            size.width == 1024
              ? "94%"
              : size.width <= 1300
              ? "89%"
              : size.width < 1500
              ? "76%"
              : "77%",
          margin: size.width <= 428 ? "30px auto" : "60px auto",
        }}
      >
        <div class="col-75" style={{ paddingLeft: 0, paddingRight: 0 }}>
          {size.width <= 428 && (
            <img
              class="boost-visibilite-on-fleek"
              style={{ marginBottom: 30 }}
              src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6239ce2c29bb67c368f8717c/img/reduire-annulation-on-fleek@1x.png"
            />
          )}
          <div class="container" style={{ paddingLeft: 0, paddingRight: 0 }}>
            <div
              className="content-bloc"
              style={{
                width: "100%",
                display: size.width > 428 ? "flex" : "inherit",
                flexDirection: size.width <= 428 && "column",
              }}
            >
              <div class="col-50" style={{ padding: 0 }}>
                <div class="ez-vo raleway-extra-bold-eerie-black-45px">
                  Diminuez les annulations
                </div>
                <div class="grce-au-planning-en">
                  <span class="roboto-normal-black-18px">
                    Grâce au SMS de rappel automatiques, envoyés avant la
                    prestation réduisez les oublis et ainsi l’absentéisme, qui
                    représente aujourd’hui un manque à gagner dans le secteur de
                    la beauté. Un système d’acompte existe également pour
                    garantir le rendez-vous. En cas d’annulation et conformément
                    à l’article L214-1 du code de la consommation, les arrhes ne
                    peuvent être remboursés, par conséquent si un rdv est
                    annulé, vous percevrez tout de même l’acompte.
                  </span>
                </div>
              </div>
              {size.width > 428 && (
                <div
                  class="col-25"
                  style={{
                    marginLeft: 40,
                    display: "flex",
                    padding: 0,
                  }}
                >
                  <img
                    class="boost-visibilite-on-fleek"
                    src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6239ce2c29bb67c368f8717c/img/reduire-annulation-on-fleek@1x.png"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Covid />
    </>
  );
};

export default PageCTA;
